const AUTH0_TOKEN_KEY = 'Auth0Token';

export const getAuth0Token = () => {
  return sessionStorage.getItem(AUTH0_TOKEN_KEY);
};

export const setAuth0Token = (token: string) => {
  return sessionStorage.setItem(AUTH0_TOKEN_KEY, token);
};
